import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as L from 'leaflet';

@Injectable()
export class LeafletService {
  public L: typeof L;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (this.platformId) {
      this.L = L;
    }
  }
}
